"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLayoutConfig = void 0;
const helpers_1 = require("../../shared/helpers");
const getLayoutConfig = (stimulus, translations, mediaAssets) => {
    const defaultConfig = JSON.parse(JSON.stringify(helpers_1.DEFAULT_LAYOUT_CONFIG));
    const { answer, distractors, trialType } = stimulus;
    defaultConfig.isPracticeTrial = stimulus.assessmentStage === 'practice_response';
    defaultConfig.isInstructionTrial = stimulus.trialType === 'instructions';
    defaultConfig.showStimImage = false;
    if (!defaultConfig.isInstructionTrial) {
        const mappedDistractors = (0, helpers_1.mapDistractorsToString)(distractors);
        const prepChoices = (0, helpers_1.prepareChoices)(answer.toString(), mappedDistractors, 'yes', trialType);
        defaultConfig.prompt = {
            enabled: false,
            aboveStimulus: false,
        };
        defaultConfig.isImageButtonResponse = true;
        defaultConfig.classOverrides.buttonClassList = ['image-medium'];
        defaultConfig.classOverrides.buttonContainerClassList = ['lev-response-row-inline', 'grid-2x2'];
        defaultConfig.response = {
            target: prepChoices.target,
            displayValues: prepChoices.choices,
            values: prepChoices.originalChoices,
            targetIndex: prepChoices.correctResponseIdx,
        };
    }
    else {
        defaultConfig.classOverrides.buttonClassList = ['primary'];
    }
    const messages = (0, helpers_1.validateLayoutConfig)(defaultConfig, mediaAssets, translations, stimulus);
    return {
        itemConfig: defaultConfig,
        errorMessages: messages,
    };
};
exports.getLayoutConfig = getLayoutConfig;
